import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getOrganizedUnitTree from '../../services/organizedUnit/getOrganizedUnitTree'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchOrganizedUnitsTreeSuccess, fetchOrganizedUnitsTreeComboByPermissionSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getOrganizedUnitByPermission from '../../services/organizedUnit/getOrganizedUnitByPermission'

export function * fetchOrganizedUnitsTree () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const UOTreeCombo = yield call(getOrganizedUnitTree, auth.token)
    yield put(fetchOrganizedUnitsTreeSuccess(UOTreeCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchOrganizedUnitsTree () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_TREE, fetchOrganizedUnitsTree)
}

export function * fetchOrganizedUnitsTreeComboByPermission ({ permissionCode }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const UOCombo = yield call(getOrganizedUnitByPermission, auth.token, permissionCode)
    yield put(fetchOrganizedUnitsTreeComboByPermissionSuccess(UOCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchOrganizedUnitsTreeComboByPermission () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_TREE_COMBO_BY_PERMISSION, fetchOrganizedUnitsTreeComboByPermission)
}
